import { observer } from 'mobx-react';
import { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { formatPriceInProduct } from '../../helpers/orderProductModal';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import { productUtils } from '~/utils/productUtils';
import './style.scss';

const ProductPrice: React.FC = observer((): JSX.Element => {
  const _price = useMemo((): number => {
    return orderProductModalStore.product ? productUtils.calculateMenuProductPrice(orderProductModalStore.product) : 0;
  }, [orderProductModalStore.product]);

  return (
    <div className="product-price-block flex-lg-row mr-3">
      <span className="product-price-block__price text-nowrap text-md-size-18">
        {orderProductModalStore.product ? formatPriceInProduct(_price) : <Skeleton width={70} />}
      </span>

      {appStore.settings?.vat_included ? <span className="product-price-block__vat text-nowrap">{localeStore.t('VAT inclusive')}</span> : null}
    </div>
  );
});

export default ProductPrice;
